/* ═══════════════════════════════════════════════════════════════
   Cart Drawer Extras — cart-drawer-extras.js
   Features:
     1. Product Recommendations carousel (lazy-loaded, drag-to-scroll)
     2. Discount code modal (applies via /checkout?discount=CODE)
     3. Order note modal (saves via /cart/update.js)

   Hooks into Motion theme's CartDrawer (#CartDrawer) and listens
   to the same events used by bundle-builder-cart.js.
═══════════════════════════════════════════════════════════════ */
(function initCartDrawerExtras() {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     HELPERS
  ───────────────────────────────────────────────────────────── */
  function cartFetch(url, opts) {
    return fetch(url, Object.assign(
      { headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } },
      opts || {}
    ));
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.moneyFormat && window.themeCurrency) {
      return window.themeCurrency.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ─────────────────────────────────────────────────────────────
     MODAL HELPERS
  ───────────────────────────────────────────────────────────── */

  function openModal(overlayId, panelId, focusId) {
    var overlay = document.getElementById(overlayId);
    var panel   = document.getElementById(panelId);
    if (!overlay || !panel) return;
    overlay.classList.add('cde-modal--open');
    overlay.setAttribute('aria-hidden', 'false');
    panel.classList.add('cde-modal--open');
    panel.setAttribute('aria-hidden', 'false');
    if (focusId) {
      setTimeout(function () {
        var el = document.getElementById(focusId);
        if (el) el.focus();
      }, 50);
    }
    // Close on Escape
    document.addEventListener('keydown', handleEscape);
  }

  function closeModal(overlayId, panelId) {
    var overlay = document.getElementById(overlayId);
    var panel   = document.getElementById(panelId);
    if (overlay) {
      overlay.classList.remove('cde-modal--open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    if (panel) {
      panel.classList.remove('cde-modal--open');
      panel.setAttribute('aria-hidden', 'true');
    }
    document.removeEventListener('keydown', handleEscape);
  }

  function handleEscape(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeModal('cdeDiscountOverlay', 'cdeDiscountModal');
      closeModal('cdeNoteOverlay', 'cdeNoteModal');
    }
  }

  /* ─────────────────────────────────────────────────────────────
     DISCOUNT MODAL
  ───────────────────────────────────────────────────────────── */
  var discountToggle = document.getElementById('cdeDiscountToggle');
  var discountOverlay = document.getElementById('cdeDiscountOverlay');
  var discountClose  = document.getElementById('cdeDiscountClose');
  var discountInput  = document.getElementById('cdeDiscountInput');
  var discountApply  = document.getElementById('cdeDiscountApply');
  var discountMsg    = document.getElementById('cdeDiscountMsg');

  if (discountToggle) {
    discountToggle.addEventListener('click', function () {
      openModal('cdeDiscountOverlay', 'cdeDiscountModal', 'cdeDiscountInput');
    });
  }
  if (discountClose) {
    discountClose.addEventListener('click', function () {
      closeModal('cdeDiscountOverlay', 'cdeDiscountModal');
    });
  }
  if (discountOverlay) {
    discountOverlay.addEventListener('click', function () {
      closeModal('cdeDiscountOverlay', 'cdeDiscountModal');
    });
  }

  // Enable Apply button only when input has a value
  if (discountInput && discountApply) {
    discountInput.addEventListener('input', function () {
      discountApply.disabled = !discountInput.value.trim();
    });
    discountInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') applyDiscount();
    });
  }

  if (discountApply) {
    discountApply.addEventListener('click', applyDiscount);
  }

  function applyDiscount() {
    if (!discountInput) return;
    var code = discountInput.value.trim().toUpperCase();
    if (!code) return;

    if (discountMsg) {
      discountMsg.textContent = 'Applying...';
      discountMsg.className = 'cde-discount-form__msg';
    }
    if (discountApply) discountApply.disabled = true;

    // Shopify validates codes server-side at /discount/{code}
    // If valid it sets the discount cookie and we redirect to checkout
    fetch('/discount/' + encodeURIComponent(code), { redirect: 'manual' })
      .then(function (r) {
        // r.ok = 200 (code valid), r.type = 'opaqueredirect' also means success
        if (r.ok || r.type === 'opaqueredirect' || r.redirected) {
          if (discountMsg) {
            discountMsg.textContent = '✓ Code applied! Taking you to checkout…';
            discountMsg.className = 'cde-discount-form__msg is-success';
          }
          setTimeout(function () {
            window.location.href = '/checkout?discount=' + encodeURIComponent(code);
          }, 800);
        } else {
          throw new Error('invalid');
        }
      })
      .catch(function () {
        if (discountMsg) {
          discountMsg.textContent = 'Code not found. Please check and try again.';
          discountMsg.className = 'cde-discount-form__msg is-error';
        }
        if (discountApply && discountInput && discountInput.value.trim()) {
          discountApply.disabled = false;
        }
      });
  }

  /* ─────────────────────────────────────────────────────────────
     NOTE MODAL
  ───────────────────────────────────────────────────────────── */
  var noteToggle   = document.getElementById('cdeNoteToggle');
  var noteOverlay  = document.getElementById('cdeNoteOverlay');
  var noteClose    = document.getElementById('cdeNoteClose');
  var noteTextarea = document.getElementById('cdeNoteTextarea');
  var noteSave     = document.getElementById('cdeNoteSave');

  if (noteToggle) {
    noteToggle.addEventListener('click', function () {
      openModal('cdeNoteOverlay', 'cdeNoteModal', 'cdeNoteTextarea');
    });
  }
  if (noteClose) {
    noteClose.addEventListener('click', function () {
      closeModal('cdeNoteOverlay', 'cdeNoteModal');
    });
  }
  if (noteOverlay) {
    noteOverlay.addEventListener('click', function () {
      closeModal('cdeNoteOverlay', 'cdeNoteModal');
    });
  }

  // Enable Save button when textarea has content
  if (noteTextarea && noteSave) {
    // Pre-existing note: enable button right away
    if (noteTextarea.value.trim()) noteSave.disabled = false;
    noteTextarea.addEventListener('input', function () {
      noteSave.disabled = !noteTextarea.value.trim();
    });
  }

  if (noteSave) {
    noteSave.addEventListener('click', saveNote);
  }

  function saveNote() {
    if (!noteTextarea) return;
    var note = noteTextarea.value;
    if (noteSave) noteSave.disabled = true;

    // /cart/update.js — note is saved on the cart object and appears on the order in Shopify Admin
    cartFetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ note: note })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        // Show brief confirmation, then close
        if (noteSave) {
          noteSave.textContent = '✓ Saved!';
          setTimeout(function () {
            noteSave.textContent = 'Save note';
            if (noteTextarea && noteTextarea.value.trim()) noteSave.disabled = false;
            closeModal('cdeNoteOverlay', 'cdeNoteModal');
          }, 900);
        } else {
          closeModal('cdeNoteOverlay', 'cdeNoteModal');
        }
      })
      .catch(function () {
        // Re-enable on error so user can retry
        if (noteSave && noteTextarea && noteTextarea.value.trim()) {
          noteSave.disabled = false;
          noteSave.textContent = 'Save note';
        }
      });
  }

  /* ─────────────────────────────────────────────────────────────
     PRODUCT RECOMMENDATIONS CAROUSEL
     ─────────────────────────────────────────────────────────────
     Three modes, configured from the Shopify admin via
     sections/cart-recs-config.liquid → window.__cdeRecsConfig:
       auto        — Shopify Related Products API (default)
       manual      — fixed list of product handles
       conditional — different sets depending on cart contents
  ───────────────────────────────────────────────────────────── */
  var _recsLoaded    = false;
  var _recsProductId = null;
  var _recsLastKey   = null; // tracks what was last rendered to avoid redundant re-renders

  var _cfg = window.__cdeRecsConfig || { mode: 'auto', title: 'You may also like', manualHandles: '', conditionalRules: [] };

  /* Update carousel heading from config */
  function applyRecsTitle() {
    var titleEl = document.getElementById('cdeRecsTitle');
    if (titleEl && _cfg.title) titleEl.textContent = _cfg.title;
  }
  applyRecsTitle();

  /* ── Fetch a product by handle and return its data ── */
  function fetchProductByHandle(handle) {
    return fetch('/products/' + handle.trim() + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ── Fetch multiple products by handle list ── */
  function fetchProductsByHandles(handlesStr) {
    var handles = handlesStr.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    return Promise.all(handles.map(fetchProductByHandle))
      .then(function (results) { return results.filter(Boolean); });
  }

  function getFirstProductId() {
    if (window._upnCartItems && window._upnCartItems.length) {
      return window._upnCartItems[0].product_id;
    }
    var row = document.querySelector('[data-products] [data-product-id]');
    return row ? row.getAttribute('data-product-id') : null;
  }

  /* ── CONDITIONAL: find matching rule for current cart ── */
  function getConditionalHandles(cartItems) {
    var rules = _cfg.conditionalRules || [];
    if (!rules.length) return null;

    var cartHandles = (cartItems || []).map(function (item) {
      // Cart API items have .handle
      return (item.handle || item.product_handle || '').toLowerCase();
    });

    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      var triggers = rule.trigger.split(',').map(function (t) { return t.trim().toLowerCase(); });
      var matched = triggers.some(function (t) { return cartHandles.indexOf(t) !== -1; });
      if (matched && rule.products) return rule.products;
    }
    return null; // no rule matched → fall back to auto
  }

  function loadRecommendations() {
    var recsEl = document.getElementById('cdeRecs');
    if (!recsEl) return;
    applyRecsTitle();

    var mode = _cfg.mode || 'auto';

    /* ── MANUAL mode ── */
    if (mode === 'manual') {
      var manualHandles = (_cfg.manualHandles || '').trim();
      if (!manualHandles) return;
      var key = 'manual:' + manualHandles;
      if (_recsLastKey === key) return;
      _recsLastKey = key;
      fetchProductsByHandles(manualHandles).then(function (products) {
        if (!products.length) return;
        renderRecommendations(products);
        recsEl.classList.remove('cart--hidden');
      });
      return;
    }

    /* ── CONDITIONAL mode ── */
    if (mode === 'conditional') {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var handlesStr = getConditionalHandles(cart.items);
          if (!handlesStr) {
            // No rule matched → fall back to auto using first cart product
            if (cart.items && cart.items.length) {
              _fetchRecsAuto(cart.items[0].product_id, recsEl);
            }
            return;
          }
          var key = 'conditional:' + handlesStr;
          if (_recsLastKey === key) return;
          _recsLastKey = key;
          fetchProductsByHandles(handlesStr).then(function (products) {
            if (!products.length) return;
            renderRecommendations(products);
            recsEl.classList.remove('cart--hidden');
          });
        })
        .catch(function () {});
      return;
    }

    /* ── AUTO mode (default) ── */
    var productId = getFirstProductId();
    if (!productId) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.items && cart.items.length) {
            _fetchRecsAuto(cart.items[0].product_id, recsEl);
          }
        })
        .catch(function () {});
      return;
    }
    _fetchRecsAuto(productId, recsEl);
  }

  function _fetchRecsAuto(productId, recsEl) {
    var key = 'auto:' + productId;
    if (_recsLastKey === key) return;
    _recsLastKey = key;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.products || !data.products.length) return;
        renderRecommendations(data.products);
        recsEl.classList.remove('cart--hidden');
        _recsLoaded = true;
      })
      .catch(function () {});
  }

  function renderRecommendations(products) {
    var track = document.getElementById('cdeRecsTrack');
    if (!track) return;
    track.innerHTML = '';

    var mode = (_cfg && _cfg.mode) || 'auto';

    products.forEach(function (product) {
      // Filter out utility/non-purchasable products
      var handle = product.handle || '';
      if (handle === 'free-returns-via-redo' || (product.title || '').toLowerCase().indexOf('free returns') === 0) return;

      // Auto mode: only show products with "complete" in the title (original behaviour)
      if (mode === 'auto') {
        if ((product.title || '').toLowerCase().indexOf('complete') === -1) return;
      }

      var variant = product.variants && product.variants[0];
      if (!variant) return;

      var price   = variant.price;
      var compare = variant.compare_at_price;
      var imgSrc  = product.featured_image || (product.images && product.images[0] && product.images[0].src);
      var title   = product.title || '';

      var imgHtml = imgSrc
        ? '<img class="cde-rec-card__img" src="' + imgSrc + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy">'
        : '<div style="width:100%;height:100%;background:#f0f0f0;"></div>';

      var compareHtml = (compare && compare > price)
        ? '<span class="cde-rec-card__compare">' + formatMoney(compare) + '</span>'
        : '';

      var card = document.createElement('div');
      card.className = 'cde-rec-card';
      card.innerHTML =
        '<div class="cde-rec-card__img-wrap">' + imgHtml + '</div>' +
        '<p class="cde-rec-card__title">' + title + '</p>' +
        '<div class="cde-rec-card__price-row">' +
          '<span class="cde-rec-card__price">' + formatMoney(price) + '</span>' +
          compareHtml +
        '</div>' +
        '<button class="cde-rec-card__add" type="button" data-variant-id="' + variant.id + '"' +
          ' aria-label="Add ' + title.replace(/"/g, '&quot;') + ' to cart">Add</button>';

      track.appendChild(card);
    });

    initCarouselDrag();
    bindAddToCart();
  }

  /* ── Drag-to-scroll (document-level, same pattern as bundle carousel) ── */
  function initCarouselDrag() {
    var overflow = document.getElementById('cdeRecsOverflow');
    var track    = document.getElementById('cdeRecsTrack');
    if (!overflow || !track) return;

    var isDragging  = false;
    var startX      = 0;
    var currentX    = 0;
    var startScroll = 0;
    var moved       = 0;

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - overflow.clientWidth);
    }

    function setTranslate(x) {
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    function onDown(e) {
      isDragging  = true;
      moved       = 0;
      startX      = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
      startScroll = currentX;
      track.classList.add('cde-dragging');
    }

    function onMove(e) {
      if (!isDragging) return;
      var x    = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      var diff = x - startX;
      moved = Math.abs(diff);
      currentX = Math.min(0, Math.max(-getMaxScroll(), startScroll + diff));
      setTranslate(currentX);
      if (moved > 5) e.preventDefault();
    }

    function onUp() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('cde-dragging');
    }

    track.addEventListener('mousedown',  onDown);
    track.addEventListener('touchstart', onDown, { passive: true });
    document.addEventListener('mousemove',  onMove);
    document.addEventListener('touchmove',  onMove, { passive: false });
    document.addEventListener('mouseup',    onUp);
    document.addEventListener('touchend',   onUp);

    // Expose moved so click handler can ignore drags
    track._cdeGetMoved = function () { return moved; };
  }

  /* ── Add to cart from carousel ── */
  function bindAddToCart() {
    var track = document.getElementById('cdeRecsTrack');
    if (!track) return;

    // Guard: remove any previous listener before adding a new one so multiple
    // calls to bindAddToCart() (on each rec reload) don't stack up handlers.
    if (track._cdeAddHandler) {
      track.removeEventListener('click', track._cdeAddHandler);
    }

    track._cdeAddHandler = function (e) {
      // Ignore drags
      if (track._cdeGetMoved && track._cdeGetMoved() > 5) return;

      var btn = e.target.closest('.cde-rec-card__add');
      if (!btn) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      // Guard: block if this button already has a fetch in flight
      if (btn.disabled || btn.classList.contains('cde-adding')) return;

      btn.disabled = true;
      btn.classList.add('cde-adding');
      btn.textContent = '…';

      cartFetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '✓ Added';
          btn.classList.remove('cde-adding');
          setTimeout(function () {
            btn.textContent = 'Add';
            btn.disabled = false;
          }, 2000);

          // Refresh the cart drawer contents via tru-store's theme event
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var drawerForm = document.querySelector('[data-cart-form]');
          if (drawerForm) drawerForm.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
        })
        .catch(function () {
          btn.textContent = 'Add';
          btn.classList.remove('cde-adding');
          btn.disabled = false;
        });
    };

    track.addEventListener('click', track._cdeAddHandler);
  }

  /* ─────────────────────────────────────────────────────────────
     INITIALISATION — load recs when cart drawer opens
  ───────────────────────────────────────────────────────────── */
  // Load recs ONLY when the drawer opens and they haven't been loaded yet.
  // The carousel never re-renders due to cart changes — there is no reason to:
  //   • Adds from the carousel are reflected immediately via the click handler
  //     (button changes to "✓ Added"), no re-render needed.
  //   • Adds from elsewhere (bundle page, other products) don't affect the
  //     carousel content at all.
  // A MutationObserver or cart event listener here would only cause unnecessary
  // re-renders and extra network requests.
  var drawer = document.getElementById('drawer-cart');
  if (drawer) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          if (drawer.classList.contains('drawer--visible')) {
            loadRecommendations();
          }
        }
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // For conditional mode: re-evaluate when cart contents change
  if (_cfg.mode === 'conditional') {
    document.addEventListener('cart:updated', function () { _recsLastKey = null; loadRecommendations(); });
    document.addEventListener('cart:refresh', function () { _recsLastKey = null; loadRecommendations(); });
  }

  // Initial load (for when the script runs after drawer is already open)
  loadRecommendations();

  /* ─────────────────────────────────────────────────────────────
     FREE SHIPPING PROGRESS BAR
  ───────────────────────────────────────────────────────────── */
  (function initFsBar() {
    var bar    = document.getElementById('freeShippingBar');
    var fill   = document.getElementById('freeShippingFill');
    var msg    = document.getElementById('freeShippingMsg');
    var icon   = document.getElementById('freeShippingIcon');
    if (!bar || !fill || !msg) return;

    var threshold = parseInt(bar.getAttribute('data-fs-threshold') || '9000', 10); // cents

    // Icons per progress stage
    function getFsIcon(pct) {
      if (pct >= 100) return '🚚'; // unlocked — truck en route
      if (pct >= 75)  return '📦'; // almost there — package ready
      if (pct >= 50)  return '🛍️'; // halfway — keep shopping
      if (pct >= 25)  return '💪'; // gaining momentum
      return '🛒';                  // just started
    }

    function updateFsBar(totalCents) {
      var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
      var unlocked = totalCents >= threshold;
      fill.style.width = pct + '%';
      fill.classList.toggle('is-unlocked', unlocked);
      msg.classList.toggle('is-unlocked', unlocked);
      if (icon) {
        icon.textContent = getFsIcon(pct);
        icon.classList.toggle('is-unlocked', unlocked);
      }
      if (unlocked) {
        msg.innerHTML = '<span class="fs-bar__icon' + (unlocked ? ' is-unlocked' : '') + '" id="freeShippingIcon" aria-hidden="true">' + getFsIcon(pct) + '</span> You\'ve unlocked <strong>free shipping!</strong>';
      } else {
        var left = formatMoney(threshold - totalCents);
        msg.innerHTML = '<span class="fs-bar__icon" id="freeShippingIcon" aria-hidden="true">' + getFsIcon(pct) + '</span> Spend <strong>' + left + '</strong> more for free shipping';
      }
    }

    // Read current cart total from the DOM (data-cart-final span updated by theme)
    function readCartTotal() {
      // Try Shopify cart API for freshest value
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { updateFsBar(data.total_price); })
        .catch(function () {
          // Fallback: parse text from price display
          var el = document.querySelector('[data-cart-final]');
          if (el) {
            var num = parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
            if (!isNaN(num)) updateFsBar(Math.round(num * 100));
          }
        });
    }

    // Listen for cart changes (theme dispatches these events)
    document.addEventListener('cart:updated', readCartTotal);
    document.addEventListener('cart:refresh', readCartTotal);
    document.addEventListener('theme:cart:update', readCartTotal);

    // Also observe the subtotal element for DOM changes (most reliable fallback)
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) {
      new MutationObserver(readCartTotal).observe(subtotalEl, { childList: true, subtree: true });
    }

    // Initial render
    readCartTotal();
  })();

    /* ─────────────────────────────────────────────────────────────
     FREEBIES — hide quantity controls, keep remove button
  ───────────────────────────────────────────────────────────── */
  (function initFreebies() {
    function tagFreebies() {
      // Identify freebie items: product link contains "freegift"
      document.querySelectorAll('.cart__items__grid').forEach(function (row) {
        var link = row.querySelector('a[href*="freegift"]');
        if (link) {
          row.classList.add('is-freebie');
        }
      });
    }

    // Run on load and on every cart update
    tagFreebies();
    document.addEventListener('cart:updated', tagFreebies);
    document.addEventListener('cart:refresh', tagFreebies);

    // Also watch the cart items container for DOM mutations (re-renders)
    var cartItems = document.querySelector('[data-line-items]');
    if (cartItems) {
      new MutationObserver(tagFreebies).observe(cartItems, { childList: true, subtree: true });
    }
  })();

})();
